import { Component, Input, Injector } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'dialogo_10',
  templateUrl: 'dialogo_10.html',
})

export class Dialogo_10Component extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  risposte_conferma = [];
  iselect_opened = [];
  risptesto: any = [];
  dialogo_counter = 0;
  showconferma: boolean = true;
  showfeed: boolean = false;
  feed = '';
  block_risposta = [];
  showtime: boolean = true;
  risp_parz: any;
  pos_risp_parz: any;
  showconferma_parz: boolean = true;
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';

  }

  ngOnInit() {
    this.events.publish('start_tempo', this.domanda);
    for (var i = 0; i < this.domanda['arrDomande'].length; i++) {
      this.risptesto[i] = { testo: '' };
      this.iselect_opened[i] = false;
      if (this.settingsmq.risposteCausali == '1')
        this.domanda['arrDomande'][i]['RispostaMicroStepList'] = this.shuffle(this.domanda['arrDomande'][i]['RispostaMicroStepList']);
    }

    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
    this.openselect(0);

  }

  openselect(i) {
    if (!this.showconferma)
      return;
    if (this.block_risposta[i] == true)
      return;

    //console.log(this.iselect_opened);
    this.iselect_opened[i] = true;
  }

  selzionata(r, i) {
    this.risp_parz = r;
    this.pos_risp_parz = i;
    this.iselect_opened[i] = false;
    this.risptesto[i] = r;
    // this.showconferma_parz = true;
  }

  sel(r, i) {
    if (this.risp_parz == undefined || this.risp_parz == null || this.risp_parz == '')
      return;
    if (!this.showconferma)
      return;
    if (this.block_risposta[i] == true)
      return;

    this.block_risposta[i] = true;

    let errate_ = [];
    let esatte_ = [];
    //console.log(r);
    if (r.punti != '0')
      esatte_.push(r.id);
    else
      errate_.push(r.id);

    //console.log(esatte_);
    setTimeout(() => {
      if (!this.settingsmq['istest'])
        this.changestyle(esatte_, errate_);
    }, 500);


    this.iselect_opened[i] = false;
    this.risptesto[i] = r;
    let risposte_output = [];

    this.risptesto.forEach(element => {
      if (element.id != undefined)
        risposte_output.push(element.id);
    });
    //this.update_output(risposte_output);
    this.risposte_conferma = risposte_output;
    if (this.risposte_conferma.length == this.domanda['arrDomande'].length)
      this.showconferma_parz = false;


    this.dialogo_counter++;
    this.openselect(this.dialogo_counter);
  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('dialogo', this.domanda, this.risposte_conferma);
  }
  position_class(h, len) {
    if (h == 0) {
      return 'first';
    }
    else if (h == len - 1)
      return 'last';
    else
      return '';
  }
  conferma(tempo?) {
    this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
      if (this.risposte_conferma.length != this.domanda['arrDomande'].length && tempo != 'tempo') {
        // this.feed = 'Devi inserire tutte le risposte';
        // this.showfeed = true;
        this.presentToast(v);
        return;
      }

      if (tempo == 'tempo')
        this.showconferma_parz = false;

        this.events.publish('stop_tempo_parziale', this.domanda);
      let errate = [];
      let esatte = [];

      for (let i = 0; i < this.domanda['arrDomande'].length; i++) {
        let r = this.domanda['arrDomande'][i];
        for (let h = 0; h < r['RispostaMicroStepList'].length; h++) {
          if (this.risposte_conferma[i] == r['RispostaMicroStepList'][h].id && r['RispostaMicroStepList'][h].punti != '0')
            esatte.push(this.risposte_conferma[i]);

          else if (this.risposte_conferma[i] == r['RispostaMicroStepList'][h].id && r['RispostaMicroStepList'][h].punti == '0')
            errate.push(this.risposte_conferma[i]);
        }

      }
      //console.log('esatte', esatte);
      //console.log('errate', errate);
      if (!this.settingsmq['istest'])
        this.changestyle(esatte, errate);
      if (errate.length == 0 && this.risposte_conferma.length > 0)
        this.feed = this.domanda['feedbackPositivo'];
      else if (esatte.length > 0)
        this.feed = this.domanda['feedbackParziale'];
      else
        this.feed = this.domanda['feedbackNegativo'];

      //tutta la logica

      this.showfeed = true;
      this.showconferma = false;
      if (this.settingsmq['istest'])
        this.prosegui();
    });
  }

  changestyle(esatte, errate) {
    var x = document.getElementsByClassName("box-dialogo-dx");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];

      if (esatte.indexOf(l['id']) != -1) {
        l.classList.add('dialogo-green');
      }
      else if (errate.indexOf(l['id']) != -1) {
        l.classList.add('dialogo-red');
      }
    }
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/dialogo_10.ts